import axios from 'axios';

const BASE_URL = import.meta.env.VITE_API_BASE_URL || '/api/admin';

const api = axios.create({
  baseURL: BASE_URL,
  headers: { 'X-Requested-With': 'XMLHttpRequest' },
  timeout: 30_000,
});

api.interceptors.request.use(async (config) => {
  const { useAuthStore } = await import('@/stores/auth.js');
  const auth = useAuthStore();
  if (auth.token) config.headers.Authorization = `Bearer ${auth.token}`;
  return config;
});

// Single-flight refresh (no refresh endpoint yet — on 401 we hard-logout)
let logoutPromise = null;

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const status = error.response?.status;
    if (status === 401 && !error.config?._noRedirect) {
      if (!logoutPromise) {
        logoutPromise = (async () => {
          const { useAuthStore } = await import('@/stores/auth.js');
          const auth = useAuthStore();
          if (auth.token) auth.softLogout();
        })().finally(() => {
          logoutPromise = null;
        });
      }
      await logoutPromise;
    }
    return Promise.reject(error);
  }
);

export default api;
